<template>
    <div class="fb">
        <div class="__gra __top"></div>
        <div class="__middle">
            <div class="container">
                <div class="">
                    <div class="logo-wrap">
                        <div class="logo">
                            <img alt="Медпервичка" :src="logo">
                        </div>
                        <div class="year">
                            <img :alt="contacts.date.year" :src="year">
                        </div>
                    </div>
                    <h1 class="title">{{ contacts.title }}</h1>
                    <template v-if="showTime">
                        <div class="buy-ticket">
                            <!-- <button
                                @click="handleClickBayTicket"
                            >Купить билет</button> -->
                            <div class="__consult">
                                <h3 class="__note">Если у Вас есть вопросы и нужна консультация</h3>
                                <button
                                    @click="handleClickConsult"
                                >Обратиться к спикерам</button>
                            </div>


                        </div>
                        <!-- <div class="conf">Конференция</div> -->
                        <div class="contact">
                            <div class="date">{{ contacts.date.day +" "+ contacts.date.month +" "+ contacts.date.year }}</div>
                            <div class="address">
                                {{ contacts.address.b1 }}<br>
                                <span>
                                    <a :href="contacts.address.url">
                                    <!-- <img class="__gl" :src="contacts.address.icon"> -->
                                    {{ contacts.address.b3 }}
                                    </a>
                                </span>
                                <!-- <br> -->
                                <div class="__stars">
                                    <IconStar/>
                                    <IconStar/>
                                    <IconStar/>
                                    <IconStar/>
                                    <IconStar/>
                                </div>
                            </div>
                            <div class="time">{{ contacts.time.raw }}</div>
                        </div>
                    </template>
                </div>
        </div>
            <!-- <div class="zapis">
                <button @click="handleClickZapis">Участвовать</button>
            </div> -->
        </div>
        <!-- <div class="__gra __bottom"></div> -->
    </div>
</template>
<script>
import contacts from '@/lib/contacts'
import logo from '@/assets/logo.svg'
import year from '@/assets/2025.svg'
import IconStar from '@/icons/IconStar.vue'
// import IconGeo from '@/icons/IconGeo.vue'
export default {
    name: 'FirstBlock',
    components: { 
        // IconGeo 
        IconStar,
    },
    emits: [ 'clickButtonConsult' ],
    props: {
        showTime: {
            type: Boolean,
            default: () => true
        }
    },
    data() {
        return {
            clientHeight: null,
            logo: logo,
            year: year,
            contacts: contacts,
        }
    },
    mounted() {
        // this.getClientSizes()
    },
    methods: {
        getClientSizes: function() {
            this.clientHeight = parseInt(document.body.clientHeight)
        },
        handleClickZapis: function() {
            document.querySelector('#form-zapis').scrollIntoView({ behavior: 'smooth' })
            document.querySelector('#form-zapis input').focus()
        },
        handleClickBayTicket: function() {
            document.querySelector('#tariff').scrollIntoView()
            window.scrollBy( 0, -60 )
        },
        handleClickConsult: function() {
            this.$emit( 'clickButtonConsult' )
        },
    },
    watch:{
        clientHeight: function(height) {
            document.querySelector('.fb').style.height = height + 'px'
        },
    }
}
</script>
<style lang="scss">
// $primary-color: #243255;
$background: #290a4f;
.fb{
    .__gra{
        // background: #290A4F;
        position: absolute;
        left: 0;
        height: 100px;
        width: 100%;
        &.__top{
            top: 0;
            background: linear-gradient(#290A4F, transparent);
        }
        &.__bottom{
            bottom: 0;
            background: linear-gradient(transparent, #290A4F );
        }
    }
    .__middle{
        height: 100%;
        background: rgba(0, 0, 0, .0 );
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        @media ( min-width: 992px ) {
            background: rgba(0, 0, 0, .31 );
        }

    }
    background-image: url('@/assets/bg.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    // background: linear-gradient(#290A4F 10%, transparent 80%, #290A4F 10% );
    // background-attachment: fixed;
    // height: max-content;
    @media ( min-height: 500px ) {
        height: 100vh;
    }
    // display: flex;
    // flex-direction: column;
    // // justify-content: space-around;
    // justify-content: space-evenly;

    .logo-wrap{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        // flex-basis: 50%;
        .logo{
            flex-grow: 1;
            flex-basis: 100%;
            @media ( min-width: 992px ) {
                flex-basis: 100%;
                max-width: 500px;
            }
        }
        .year{
            flex-basis: 100%;
            max-width: 140px;
            // overflow: hidden;
            // object-fit: contain;
            @media ( min-width: 992px ) {
                max-width: 190px;
                margin-left: 1em;
            }
            max-width: 33%;
            img{
                height: 100%;
                width: auto;
            }
        
        }
    }
    h1.title{
        font-size: 1.5em;
        @media ( min-width: 992px ) {
            font-size: 2em;
        }
    }
    .contact{
        display: flex;
        justify-content: flex-start;
        font-size: 1.5em;
        font-weight: 700;
        color: #fff;
        a{
            color: #fff;
        }
        @media ( max-width: 992px ) {
            flex-direction: column;
            text-align: left;
            padding-left: 10px;
            // margin-bottom: 1em;
            &>div{
                padding-top: .75em;
            }
        }
        .address{
            text-align: left;
            span{
                font-size: .8em;
                font-weight: 200;
                text-transform: none;
                margin-right: 10px;
                // &:nth-child(3){
                //     text-wrap: nowrap;
                // }
            }
            a{
                text-decoration: none;
                border-bottom: solid 1px #fff;
            }
            .__stars{
                // background-color: aliceblue;
                display: inline-flex;
                // align-self: center;
                // justify-content: center;
            }
            // img.__gl{
            //     height: 18px;
            //     width: 18px;
            // }
        }
        .date, .address, .time{
            text-transform: uppercase;
            margin-right: 100px;
            // flex-basis: 33%;
        }
    }

    .buy-ticket{
        display: flex;
        padding: 2em 0;
        @media ( max-width: 578px ) {
            padding-left: 10px;
        }
        .__consult{
            .__note{

            }
            text-align: start;
        }
        button{
            border: none;
            height: 40px;
            border-radius: 20px;
            background: #1E9BD8;
            color: #fff;
            text-transform: uppercase;
            line-height: 0;
            font-weight: 700;
            font-size: 1.25em;
            padding: 10px 24px;
            cursor: pointer;
            transition: .4s;
            &:hover{
                transition: .4s;
                color: #1E9BD8;
                background: #fff;
            }
        }
    }
}
// .logo{
//     // margin: 20px 0;
//     // @media ( min-width: 992px ) {
//     //     margin: 46px 0;
//     // }
//     // padding-left: .5em;
//     // padding-right: .5em;
// }
// .conf{
//     @media ( max-width: 360px) {
//         font-size: 1.85em;
//     }
//     // font-size: 2.25em;
//     font-size: 1.75em;
//     color: #fff;
//     font-weight: 400;
//     margin-bottom: .5em;
//     // margin-top: 60px;
//     // font-weight: 400 !important;
//     text-align: right;
//     padding-left: 10px;
//     padding-right: 10px;
//     // span{
//     // }
// }
// h1{
//     text-align: left;
//     // font-size: .75em;
//     font-weight: 400;
// }

// .date{
//     // font-size: 1.85em;
//     color: #fff;
//     // text-align: right;
//     // padding-right: 10px;
// }
// .time{
//     color: #fff;
//     text-align: right;
//     // padding-right: 10px;
// }
// .address{
//     color: #fff;
//     text-align: right;
//     // font-size: 1.25em;
//     // padding-right: 10px;
//     a{
//         color: #fff;
//         text-decoration: none;
//         // text-decoration-color: #1e92ff;
//     }
//     svg{
//         height: 18px;
//         width: 18px;
//         path{
//             stroke: #fff;
//         }
//         margin-right: 5px;
//     }
// }
// .geo{
//     height: 54px;
//     width: auto;

// }
// .zapis{
//     // margin-top: 70px;
//     button{
//         border: none;
//         // background-image: linear-gradient(#0085c6, $primary-color);
//         // background-color: #0085c6;
//         background-color: $primary-color+a1;
//         border-radius: 10px;
//         // border: solid 1px #fff;
//         height: 60px;
//         width: 260px;
//         padding: .5em;
//         color: #fff;
//         // width: 100px;
//         font-size: large;
//         text-transform: uppercase;
//         // box-shadow: 0px 0px 10px 0px #fff;
//         // box-shadow: 0px 0px 90px -10px #fff;
//         box-shadow: 0px 0px 4px 0px #fff;
//         // font-weight: 400;
//         @media ( max-width: 265px ) {
//             width: 100%;
//             font-size: medium;
//             height: 46px;
//         }
//     }
// }
</style>